<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M7.5 4.763V3.195c-.6.158-1.162.405-1.672.72L6.923 5.01c.187-.09.375-.18.577-.247Zm-5.355-.705 1.77 1.77a5.944 5.944 0 0 0 .855 7.403L3 14.999h4.5v-4.5l-1.68 1.68A4.503 4.503 0 0 1 4.5 9c0-.75.188-1.455.51-2.077l6.06 6.06a3.971 3.971 0 0 1-.578.255v1.567a6.165 6.165 0 0 0 1.673-.72l1.77 1.77.952-.953L3.105 3.105l-.96.953ZM15 3h-4.5v4.5l1.68-1.68A4.503 4.503 0 0 1 13.5 9c0 .75-.188 1.455-.51 2.078l1.095 1.095a5.944 5.944 0 0 0-.855-7.402L15 2.999Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
